import axios from 'axios';

const client = axios.create({
  baseURL: process.env.THANOS_API,
});

export default client;
